export default __webpack_public_path__ + "static/media/fond.7e9d7bda.jpg";